// @flow
/* eslint-disable react/jsx-no-bind */
import * as React from 'react';
import {
    Button,
    Box,
    Switch as NeoSwitch,
    Stack,
    Text,
    Flex,
    Divider
} from '@locus-taxy/neo-ui';

import MaraOnlyTag from '../components/MaraOnlyTag';

const containerStyles = {
    // Styles for action links ('View Custom Fields') + Switch
    card: { backgroundColor: 'white', padding: 4, borderRadius: '4px' },
    // Styles for boolean control in Object array fields form (in edit view)
    field: { px: 2 },
    none: {}
};

type Props = {
    value: boolean,
    onChange: (value: boolean) => void,
    disabled: boolean,
    label: string,
    description?: ?string,
    action?: { text: string, onClick: () => void },
    isMaraOnlyField?: boolean,
    style: 'card' | 'field' | 'none'
};

const Switch = ({
    label,
    disabled,
    description,
    action,
    isMaraOnlyField,
    style,
    value,
    onChange
}: Props): React.Node => {
    return (
        <Box {...containerStyles[style]}>
            <Stack space="xSmall">
                <Flex justifyContent="space-between">
                    <Text fontSize={2} fontWeight={400}>
                        {label}
                    </Text>
                    <NeoSwitch
                        checked={value}
                        disabled={disabled}
                        onChange={() => {
                            onChange(!value);
                        }}
                    />
                </Flex>
                {description || isMaraOnlyField ? (
                    <>
                        <Divider color="grey.200" />
                        <Flex justifyContent="space-between">
                            {description && (
                                <Text
                                    color="grey.600"
                                    fontSize={2}
                                    fontWeight={400}
                                >
                                    {description}
                                </Text>
                            )}
                            {/* Show an indicator for the fields which is visible only to Mara personnel */}
                            {isMaraOnlyField && (
                                <Box ml="auto">
                                    <MaraOnlyTag />
                                </Box>
                            )}
                        </Flex>
                    </>
                ) : null}
                {action && (
                    <Box ml="auto">
                        <Button palette="primary" onClick={action.onClick}>
                            {action.text}
                        </Button>
                    </Box>
                )}
            </Stack>
        </Box>
    );
};

export default Switch;
